export default "__VITE_ASSET__BCTu1GmY__"